import script from "./section-1.vue?vue&type=script&setup=true&lang=js"
export * from "./section-1.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__